// extracted by mini-css-extract-plugin
module.exports = {"healthgoal":"tiles_healthgoal__3-mci","tileSwitch":"tiles_tileSwitch__2iGhl"};